import type { CallScriptStepInterface, CallScriptStepUpsertBody, CallScriptStepVersionInterface } from "@swivl-mono/types";

import { APIService } from "../Service/API.Service";

// LINK apps/server/src/API/CallScript/CallScriptStep.Controller.ts
/**
 * The org's step-library rows (ENG-3402). Reads are open to members (the pickers need the resolved
 * library); writes are Swivl staff only — the server checks the member's account kind.
 */
export class CallScriptStepAPI {
  /** Every step row in the org; Studio merges them with the platform catalog via `resolveStepLibrary`. */
  static async listRows(orgId: number): Promise<CallScriptStepInterface[]> {
    return APIService.Server.get<CallScriptStepInterface[]>(`/call-script-steps/org/${orgId}`);
  }

  /** Create an org step or override a platform step. Free text is LLM-checked on the server; a rejection is a 4xx with the notes. */
  static async upsert(orgId: number, body: CallScriptStepUpsertBody): Promise<CallScriptStepInterface> {
    return APIService.Server.put<CallScriptStepInterface>(`/call-script-steps/org/${orgId}`, body);
  }

  /** Revert a platform step to its default, or delete an org-added step (refused while a script uses it). */
  static async remove(orgId: number, id: number): Promise<{ ok: true }> {
    return APIService.Server.delete<{ ok: true }>(`/call-script-steps/org/${orgId}/${id}`);
  }

  static async listVersions(orgId: number, id: number): Promise<CallScriptStepVersionInterface[]> {
    return APIService.Server.get<CallScriptStepVersionInterface[]>(`/call-script-steps/org/${orgId}/${id}/versions`);
  }

  /** Save the given version's snapshot as a NEW revision. */
  static async restore(orgId: number, id: number, revision: number): Promise<CallScriptStepInterface> {
    return APIService.Server.post<CallScriptStepInterface>(`/call-script-steps/org/${orgId}/${id}/restore/${revision}`, {});
  }
}
